import useResourcesByType from './useResourcesByType';

/**
 * Hook to fetch video resources for a user
 * Follows the same pattern as other resource hooks in the web app
 * @param {string} useruuid - User UUID to fetch videos for
 * @param {boolean} shared - Whether to fetch shared videos (default: false for own gallery)
 * @returns {Object} Query result with data, isLoading, error
 */
const useVideoMessageResource = ({ useruuid, shared = false }) => {
  return useResourcesByType({
    useruuid,
    resourceType: 'video-message',
    shared,
    details: true,
  });
};

export default useVideoMessageResource;
